import { actions } from "@grandvisionhq/state";
import { startPrescriptionGlassesConfiguration } from "../../../state/actions.js";
const initialState = {};
const reducer = actions.reducer(
  initialState,
  /**
   * Set the correct frameSku and always reset the configurator to the initial state
   */
  actions.on(
    startPrescriptionGlassesConfiguration,
    (s, { payload: { frameSku, isExtraValidationStepEnabled, rxEntryTypes, bookAppointmentRoute } }) => {
      return {
        ...initialState,
        frameSku,
        isExtraValidationStepEnabled,
        rxEntryTypes,
        bookAppointmentRoute
      };
    }
  )
);
export {
  initialState,
  reducer
};
//# sourceMappingURL=reducer.js.map
